export type AppConfig = {
  server: string;
  connectionErrorTimeout: number;
  useTurnServer: boolean;
  turnServer: string;
  turnUser: string;
  turnCredential: string;
  testMode: boolean;
  showSignerPrompt: boolean;
  showGloss: boolean;
  pendoApiKey?: string;
  pendoConversationFeedbackGuideId?: string;
};

export const defaultAppConfig: AppConfig = {
  server: 'http://127.0.0.1:3001',
  connectionErrorTimeout: 10000,
  useTurnServer: false,
  turnServer: '',
  turnUser: '',
  turnCredential: '',
  testMode: false,
  showSignerPrompt: false,
  showGloss: false,
  pendoApiKey: '',
  pendoConversationFeedbackGuideId: '',
};
